class PopupTab extends HTMLElement {
    constructor() {
      super();
      this.heading = this.dataset.heading;
      this.popupLink = this.querySelector('.popup-link');
      this.content = document.querySelector(`#poput-tab-${this.heading}-content`);
      this.mask = this.content.querySelector('.popup-layout-bg');
      this.btnClose = this.content.querySelector('.popup-close');

    }
  
    connectedCallback() {
        this.popupLink.addEventListener('click', this.open.bind(this))
        this.mask.addEventListener('click', this.close.bind(this))
        this.btnClose.addEventListener('click', this.close.bind(this))
    }

    open(e) {
        e.preventDefault();
        this.content.classList.add('open');
    }
    close(e) {
        e.preventDefault();
        this.content.classList.remove('open');
    }

  }

if (!customElements.get('popup-tab')) {
    customElements.define('popup-tab', PopupTab);
  }
  